import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'
import { getDateMMDDYYYY } from '_helpers'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        var hist = {};
        var nextWeek = new Date();
        nextWeek.setDate(nextWeek.getDate() + 7);

        Object.values(action.payload.entities.patients).forEach(x => {
            hist[x.id] = {
                id: x.id,
                filter: 'all',
                startDate: getDateMMDDYYYY(new Date().toString()),
                endDate: getDateMMDDYYYY(nextWeek.toString()),
                sortColumn: 'date',
                sortOrder: 'asc'

            };
        });
        state = { ...state, ...hist };

        return state;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        var hist = {};

        if (action.payload.patientsContainer.entities.admissions) {

            var nextWeek = new Date();
            nextWeek.setDate(nextWeek.getDate() + 7);

            Object.values(action.payload.patientsContainer.entities.patients).forEach(x => {
                hist[x.id] = {
                    id: x.id,
                    filter: 'all',
                    startDate: getDateMMDDYYYY(new Date().toString()),
                    endDate: getDateMMDDYYYY(nextWeek.toString()),
                    sortColumn: 'date',
                    sortOrder: 'asc'
                };
            });
        }
        state = { ...state, ...hist, ...action.payload.ui.apptHist };
        return state;
    },
    [patientActions.closeSuccess]: (state, action) => {
        delete state[action.payload];
    },
    [patientActions.changeApptHistFilter]: (state, action) => {
        state[action.payload.ptno].filter = action.payload.filter
    },
    [patientActions.changeApptHistStartDate]: (state, action) => {
        state[action.payload.ptno].startDate = action.payload.startDate
    },
    [patientActions.changeApptHistEndDate]: (state, action) => {
        state[action.payload.ptno].endDate = action.payload.endDate
    },
    [patientActions.changeApptHistSort]: (state, action) => {
        if (action.payload.sortColumn === state[action.payload.ptno].sortColumn) {
            state[action.payload.ptno].sortOrder = state[action.payload.ptno].sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
            state[action.payload.ptno].sortColumn = action.payload.sortColumn;
            state[action.payload.ptno].sortOrder = 'asc';
        }
    }

})


